import { render, staticRenderFns } from "./ItemLicenseSaveLayout.vue?vue&type=template&id=16c6de72&scoped=true"
import script from "./ItemLicenseSaveLayout.vue?vue&type=script&lang=js"
export * from "./ItemLicenseSaveLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c6de72",
  null
  
)

export default component.exports